import classNames from "classnames";
import { renderContent } from "@/lib/htmlContentHelpers";

type InteractionDescriptionContentProps = {
  content: string | null | undefined;
  className?: string;
};

/**
 * Typography shared by the interaction details page, side sheet, and feed
 * previews. `whitespace-normal` / `font-normal` beat inherited ListItem
 * `longContent` (`whitespace-pre-line` + `text-body-large-semibold`) so
 * headings and lists keep the same spacing as the details page.
 */
export const interactionDescriptionClassName =
  "whitespace-normal font-normal text-body-large text-sys-brand-on-surface break-words [&_p]:text-body-large [&_li]:text-body-large [&_p]:mb-1 [&>:first-child]:mt-0 [&_h1:not(:first-child)]:mt-3 [&_h2:not(:first-child)]:mt-3 [&_h3:not(:first-child)]:mt-3 [&_ul:not(:first-child)]:my-2 [&_ol:not(:first-child)]:my-2";

/**
 * View-only interaction description. Detects pasted markdown vs plain notes
 * so **bold** renders as emphasis without rewriting ordinary staff text.
 */
export default function InteractionDescriptionContent({ content, className }: InteractionDescriptionContentProps) {
  return (
    <div
      data-testid="interaction-description-content"
      className={classNames(interactionDescriptionClassName, className)}
    >
      {renderContent(content, { detectMarkdown: true, enhancedCleanup: false, allowHtml: false })}
    </div>
  );
}
